import React from 'react';
import { formatVietnamDateTime } from '../../utils/vietnamDateTime';

export interface RegistrationActivityLog {
  id: string;
  action: string;
  summary: string;
  performerName?: string | null;
  performerRole?: string | null;
  createdAt: string;
  performer?: {
    name?: string | null;
    role?: string | null;
  } | null;
}

function resolvePerformerLabel(log: RegistrationActivityLog): string {
  const name = log.performer?.name || log.performerName || 'Hệ thống';
  const role = log.performer?.role || log.performerRole;
  const roleLabels: Record<string, string> = {
    RESIDENT: 'Cư dân',
    STAFF: 'Ban quản lý',
    OPERATOR: 'Vận hành',
    SUPERADMIN: 'Quản trị',
  };
  if (!role) return name;
  return `${name} (${roleLabels[role] || role})`;
}

interface RegistrationActivityLogsPanelProps {
  logs: RegistrationActivityLog[];
  loading?: boolean;
}

export const RegistrationActivityLogsPanel: React.FC<RegistrationActivityLogsPanelProps> = ({
  logs,
  loading = false,
}) => (
  <div className="bg-white border border-gray-200 rounded-lg p-4 mt-6">
    <h3 className="text-lg font-semibold text-gray-900 mb-4">Nhật ký thao tác</h3>
    {loading ? (
      <p className="text-sm text-gray-500">Đang tải nhật ký...</p>
    ) : logs.length === 0 ? (
      <p className="text-sm text-gray-500">Chưa có nhật ký thao tác.</p>
    ) : (
      <div className="space-y-3">
        {logs.map((log) => (
          <div key={log.id} className="border border-gray-100 rounded-lg p-3 text-sm">
            <div className="flex flex-wrap justify-between gap-2">
              <span className="font-medium text-gray-900">{log.summary}</span>
              <span className="text-gray-500">{formatVietnamDateTime(log.createdAt)}</span>
            </div>
            <div className="text-gray-600 mt-1">{resolvePerformerLabel(log)}</div>
          </div>
        ))}
      </div>
    )}
  </div>
);
